import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const tag = css`
  height: 27px;
  background-color: ${colors.warning.default};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 0 10px;
  box-sizing: border-box;

  & span {
    color: ${colors.white};
    font-size: ${fonts.size.smallest};
    font-weight: ${fonts.weight.medium};
  }
`;

export const icon = css`
  min-width: 12px;
  margin-bottom: 1px;

  & + span {
    margin-left: 5px;
  }
`;
